import { useState, useEffect, useContext, useRef } from 'react';

import { SaleListContext } from '../SaleListContext';

export function SaleLabel(props: any) {
  const sale = props.sale;

  const isFullAccess = useContext(SaleListContext).isFullAccess;
  const favoriteColor = useContext(SaleListContext).favoriteColor;
  const benefitColor = useContext(SaleListContext).benefitColor;

  const labelStyle = {
    margin: '0 2px',
  };


  return (
    <div style={{
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '1px 0 2px',
    }}>

      {/* プラス無料 */}
      {(sale.free_type == 2 && !isFullAccess) &&
        <span className='label label-danger' style={labelStyle}>プラス無料</span>
      }

      {/* シリーズ(複数動画) */}
      {(sale.movie_amount > 1) &&
        <span className='label label-primary' style={labelStyle}>動画{sale.movie_amount}セット</span>
      }

      {/* 購入済み */}
      {(sale.purchase_id && !isFullAccess) ?
        <span className='label label-warning' style={labelStyle}>購入済み</span>
      :
        <>
          {/* チケット */}
          {(sale.ticket > 0 && !isFullAccess) &&
            <span className='label label-success' style={labelStyle}>チケット{sale.ticket}枚</span>
          }
          {/* 価格 */}
          {(sale.price > 0 && !isFullAccess) &&
            <span className='label label-warning' style={labelStyle}>{sale.price}円</span>
          }
        </>
      }

      {/* 特典付 */}
      {(sale.exist_pdf) &&
        <span className='label' style={{...labelStyle, backgroundColor: benefitColor}}>特典付</span>
      }

      {/* お気に入り */}
      {(sale.is_favorite) &&
        <span className='label' style={{...labelStyle, backgroundColor: favoriteColor}}>お気に入り</span>
      }

    </div>
  );
}